import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

const routeMap: Record<string, string> = {
  '/': '首页',
  '/category': '分类',
  '/category/korean': '韩漫',
  '/category/japanese': '日漫',
  '/category/chinese': '国漫',
  '/comic': '漫画详情',
  '/about': '关于我们',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  if (items) {
    return (
      <nav aria-label="Breadcrumb" className="py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && (
                <span className="text-foreground-400">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              )}
              {item.href && i < items.length - 1 ? (
                <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className={i === items.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    );
  }

  const paths = location.pathname.split('/').filter(Boolean);
  const breadcrumbItems: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (paths.length > 0) {
    let currentPath = '';
    paths.forEach((path) => {
      currentPath += `/${path}`;
      const label = routeMap[currentPath] || path;
      breadcrumbItems.push({
        label,
        href: currentPath === location.pathname ? undefined : currentPath,
      });
    });
  }

  return (
    <nav aria-label="Breadcrumb" className="py-3">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        {breadcrumbItems.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && (
              <span className="text-foreground-400">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            )}
            {item.href ? (
              <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={i === breadcrumbItems.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}